export default __webpack_public_path__ + "static/media/img-butcher2.d7319791.svg";